export default {"src":"/_next/static/media/nami.2245724d.svg","height":500,"width":486,"blurWidth":0,"blurHeight":0};